import React, { useState, useContext, useEffect } from 'react'
import Footer from './organisms/Footer'
import Header from './organisms/Header'
import TopBanner from './organisms/TopBanner'
import { Mobile } from './util/breakpoints'
import NavigationMobile from './organisms/NavigationMobile'
import { HeaderThemeContext, BlogArchiveSlugContext } from '../context'
import Loader from './molecules/Loader'
import { useLocation } from './Router'

import ReactPixel from 'react-facebook-pixel'
import { hotjar } from 'react-hotjar'

import Cookiebot from './util/cookiebot'
import { getCurrentLocale, locales } from '../api/index'
import useSiteData from "../useSiteData"

// Temporarily disable the geo locator 6/7 - 2023
// https://app.asana.com/0/598185456966358/1204954013824306/f
// import RedirectToLocalizedSite from './organisms/RedirectToLocalizedSite'

function initializeFbPixel() {
  ReactPixel.init('1670317436551191')
  ReactPixel.pageView()
}

// This is required to not re-render root
const Site = ({ banner, children }) => {
  const { theme } = useContext(HeaderThemeContext)
  const [isMenuActive, setMenuActive] = useState(false)
  const [headerTheme, setHeaderTheme] = useState(theme)
  const [vh, setVh] = useState(0)
  const { pathname } = useLocation()
  const [topBannerOffset, setTopBannerOffset] = useState(0)

  const [delay3rdPartyScriptFlags, SetDelay3rdPartyScriptFlags] = useState( { cookieBotLoaded: false, windowLoaded: false } )

  const currentLocale = getCurrentLocale()

  const blogArchiveSlug = useSiteData().blogSlug
  
  // initialize cookiebot and set flags for if 3rd party scripts sholud be loaded/initialized
  useEffect(() => {
    if (typeof window !== 'undefined') {

      // initialize cookiebot. if returned status is loaded we should initialize 3rd party scripts
      Cookiebot.init({debug:false, language: currentLocale}).then( ( { status } ) => {        
        if( status == 'loaded' ) {
          SetDelay3rdPartyScriptFlags( prevState => ({ ...prevState, cookieBotLoaded: true }) )
        }
      })

      // add eventlistener for window.load to dealy loading of 3rd party scripts
      window.addEventListener( 'load', (e) => {
        SetDelay3rdPartyScriptFlags( prevState => ({ ...prevState, windowLoaded: true }) )
      }, true)

    }
  }, [])

  useEffect(() => {
    setVh(window.innerHeight * 0.01)
    // Change vh-unit on resize
    return window.addEventListener('resize', () => setVh(window.innerHeight * 0.01))
  }, [])

  useEffect(() => document.documentElement.style.setProperty('--vh', `${ vh }px`))

  // we want to delay the loading of 3rd party scripts until window is loaded (hopefully that will improve pagespeed scores) 
  // and only when initialization of cookie bot returns loaded (i.e only on first load and not after navigating the site using the menu)
  useEffect(() => {
    if( delay3rdPartyScriptFlags.cookieBotLoaded &&  delay3rdPartyScriptFlags.windowLoaded ) {
      initializeFbPixel()
      hotjar.initialize(329027, 6)
    } 
  }, [ delay3rdPartyScriptFlags ])

  
  return <>
    <BlogArchiveSlugContext.Provider value={{blogSlug: blogArchiveSlug}}>
    <TopBanner banner={ banner } setTopBannerOffsetHeight={ (offsetHeight) => setTopBannerOffset(offsetHeight) } />

    <Header
      onMenuToggleButtonClick={ () => setMenuActive(!isMenuActive) }
      isMenuOpen={ isMenuActive }
      isActive={ isMenuActive }
      topBannerOffset={ topBannerOffset }
    />

    <Mobile>
      <NavigationMobile isActive={ isMenuActive } onCloseMenu={ () => setMenuActive(false) }/>
    </Mobile>

    <div id="modal"/>

    { /* Temporarily disable the geo locator 6/7 - 2023
     typeof window !== 'undefined' && 
      <RedirectToLocalizedSite /> 
    */
    }

    { children }

    <Footer/>
    </BlogArchiveSlugContext.Provider>
   </>
}

export default ({ banner, children }) => {
  return (
    <>
      <Site banner={banner}>{ children }</Site>
    </>
  )
}
